import { Grid } from '@mui/material'
import { memo, useCallback, useMemo } from 'react'
import { FormFieldType } from 'types/types';
import { EFormFieldType } from 'enum/EFormFieldType';
import FormField from 'components/inputs/FormField/FormField';



function ProductDescriptionForm() {

  const fields: FormFieldType[] = useMemo(() => {
    return [
      {
        name: 'translations.en.description',
        type: EFormFieldType.TEXTAREA,
        placeholder: 'English description',
        label: 'English Description',
        required: true,
        visible: true,
      },
      {
        name: 'translations.ar.description',
        type: EFormFieldType.TEXTAREA,
        placeholder: 'Arabic description',
        label: 'Arabic Description',
        required: true,
        visible: true,
      },
    ]
  }, []);


  const renderFields = useCallback(() => {
    return (
      <>
        {fields.map((field) =>
          field.visible ? <FormField key={field.name} field={field} /> : null
        )}
      </>
    );
  }, [fields]);

  return (
    <Grid container spacing={1.5} flex={1}>
      {renderFields()}
    </Grid>
  )
}

export default memo(ProductDescriptionForm);
